/** O Brain em camadas (AB#86817): histórico da Soul e trilha da Mind. */

export interface BrainAuthor {
  id: string;
  full_name: string | null;
  email: string;
}

export interface SoulVersion {
  version: number;
  content: string;
  created_at: string | null;
  author: BrainAuthor | null;
}

export type MindChangeAction = 'create' | 'update' | 'delete' | 'restore';
export type MindChangeSource = 'ui' | 'conversation' | 'workflow';

export interface MindBlockSnapshot {
  field_name: string;
  title: string;
  description: string | null;
  block_type: string;
  content: Record<string, unknown>;
  order_index: number;
  is_active: boolean;
}

export interface MindChange {
  id: string;
  block_id: string | null;
  field_name: string;
  action: MindChangeAction;
  source: MindChangeSource;
  before: MindBlockSnapshot | null;
  after: MindBlockSnapshot | null;
  undone_by_change_id: string | null;
  created_at: string | null;
  actor: BrainAuthor | null;
}

/** Quantos caracteres da Mind entram no brain_load; a API reparte entre os blocos. */
export interface MindSettings {
  load_budget: number;
}

export const MIND_LOAD_BUDGET_MIN = 1000;
export const MIND_LOAD_BUDGET_MAX = 30000;
export const MIND_LOAD_BUDGET_STEP = 500;
export const MIND_LOAD_BUDGET_DEFAULT = 6000;
